<mat-dialog-content class="mat-typography" class="TC_container">
  <div class="section_login" style="position: relative; padding: 0px 20px 0 20px">

    <button style="outline: none;" class="close-button forgetPass" [mat-dialog-close]="true" id="closeBtn">
      <img src="../../../assets/icons/x-button.svg">
    </button>

    <div class="row" style=" width: 100%; margin: auto;">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12  position-relative">
        <h2 style="color: rgba(0, 0, 106, 1);font-size: 22px;font-weight: 700;"> Items </h2>
        <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 fav_noDataScreen" *ngIf="productsList.length == 0 || productsList == undefined">
          <h4>There are no products in this restaurant</h4>
        </div>
        <div class="scroll-content" *ngIf="productsList.length > 0 || productsList != undefined">
          <div class="row productlist">
            <div class="col-md-6" *ngFor="let val of productsList">
              <div style="background: rgba(245, 246, 252, 1); border-radius: 10px; padding: 15px; margin-top: 10px;">
                <div>
                  <img class="food-img" style="border-radius: 10px; width: 100%; height: 150px;" [src]="val.productImage" />
                </div>

                <div style="margin-top: 10px; display: flex; justify-content: space-between;">
                  <div class="fries-text">{{val.productName}}</div>
                </div>

                <div style="margin-top: 10px;" class="num-align">
                  <div style="margin-top: 10px;">
                    <div class="amount-2">$ {{convertToDecimal(val.productPrice)}}</div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

<p>&nbsp;</p>



      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 0 60px 17px;" class="accept-btn">
  <button mat-raised-button color="warn" class="authSignIn tc_ac_btn" [mat-dialog-close]="true"
    (click)="onClickPP()">Ok</button>
  <p>&nbsp;</p>

</mat-dialog-actions>
